var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.globalSections)?_c('div',_vm._l((_vm.globalSections),function(section){return _c('div',{key:section._uid},[_c('StoryblokResolver',{attrs:{"block":section,"storyFields":section}})],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }